import React from 'react';
import BadgeBase, { TBadge } from './BadgeBase';
import { BadgeSignals } from '../../types/TEBadgeSignal';

const Neutral = (props: Omit<TBadge, 'signal'>) => <BadgeBase {...props} signal={BadgeSignals.Neutral} />;

export default Neutral;
